import { render, staticRenderFns } from "./MonitorStatusTag.vue?vue&type=template&id=1a44456e"
import script from "./MonitorStatusTag.vue?vue&type=script&lang=js"
export * from "./MonitorStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports